import React from "react"
import Image from "next/image"

type Props = {
  title: string
  children: any
  path: any
  alt: string
  width: number
  height: number
  className?: string
}

const ImageContent: React.FC<Props> = ({
  title,
  children,
  path,
  alt,
  width,
  height,
  className
}) => {
  return (
    <div className={`section-py case-study-main dark:text-light ${className}`}>
      <div className="container lg:container md:mx-auto">
        <div className="row grid md:grid-cols-12 lg:grid-cols-12 bs-gy-10">
          <div className="xl:col-span-5 lg:col-span-5 md:col-span-12">
            <div className="key-challenges-image">
              <Image
                src={path}
                className="img-fluid"
                alt={alt}
                title={alt}
                width={width}
                height={height}
                loading="lazy"
              />
            </div>
          </div>
          <div className="xl:col-span-6 xl:col-start-7 lg:col-span-6 md:col-span-12">
            <div>
              <h2 className="mb-5 fw-700 fs-xl">{title}</h2>
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ImageContent
